import React from 'react';
import {formatPeso,formatDate} from '../helpers';
import Strings from "../assets/strings";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  TableContainer,
  Typography, Theme, Box, Button, TableFooter,
} from '@mui/material';

import makeStyles from "@mui/styles/makeStyles";
import {IAmortizacion} from "../redux/types/IPrestamo";


const useStyles = makeStyles((theme:Theme) => ({
  root: {
    // width: '100%',
    // overflowX: 'auto',
  },
  barTitle:{
    // padding: "6px 12px",
    // background: theme.palette.grey[200],
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    "& .total":{
      fontSize: 14,
      color: "rgba(0, 0, 0, 0.87)",
      display: "flex",
      alignItems: "center",
      textAlign: "right",
      "& div:first-child":{
        marginRight: 10
      },
      "& div:last-child":{
        textAlign: "right"
      },
      "& span":{
        color: theme.palette.secondary.main,
      },
    },
    // [theme.breakpoints.down(undefined)]: {
    //   flexDirection: "column",
    //   alignItems: "center",
    //   "& .total":{
    //     marginTop:5,
    //   }
    // }
  },
}));


export default function ListAmortizacion({ data = [],noHead=false, onTabClick,notasCount }:{notasCount?:number, data:IAmortizacion[],noHead?:boolean, onTabClick?:(tab:number)=>void }) {
  const classes = useStyles();

  //----
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event:any, newPage:number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event:React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  //---
  const totalCapital = data.reduce((a, b) => +a + (b.capital??0), 0);
  const totalInteres = data.reduce((a, b) => +a + (b.interes??0), 0);
  const totalPago = data.reduce((a, b) => +a + (b.total??0), 0);
  const totalSeguro = data.reduce((a, b) => +a + (b.seguro??0), 0);
  return (
    <>
      {!noHead && onTabClick &&
          <div className={classes.barTitle}>
            <Box display={"flex"}>
              <Button onClick={()=>onTabClick(1)} variant="text" sx={{textTransform: "capitalize",height: "30px"}}>{Strings.pagos}</Button>
              <Button onClick={()=>onTabClick(2)} variant="text" sx={{textTransform: "capitalize",height: "30px",background:"#eeeeee !important"}}>{Strings.amortizacion}</Button>
              <Button onClick={()=>onTabClick(3)} variant="text" sx={{textTransform: "capitalize",height: "30px"}}>{Strings.notas} ({notasCount ??0})</Button>

            </Box>

            <div className="total">
            </div>
          </div>
      }
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>No - {Strings.fecha}</TableCell>
              <TableCell align={"right"}>{Strings.cuota}</TableCell>
              <TableCell align={"right"}>{Strings.interes}</TableCell>
              <TableCell align={"right"}>{Strings.capital}</TableCell>
              <TableCell align={"right"}>{Strings.seguro}</TableCell>
              <TableCell align={"right"}>{Strings.capitalRestante}</TableCell>

            </TableRow>
          </TableHead>
          <TableBody>
            {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(n =>
                <TableRow key={n.cuota}>
                  <TableCell>{n.cuota+" - "+formatDate(n.fecha)}</TableCell>
                  <TableCell align={"right"} sx={{background: "#ebebeb",fontWeight: "bold"}}>{formatPeso(n.total)}</TableCell>
                  <TableCell align={"right"}>{formatPeso(n.interes)}</TableCell>
                  <TableCell align={"right"}>{formatPeso(n.capital)}</TableCell>
                  <TableCell align={"right"}>{formatPeso(n.seguro)}</TableCell>
                  <TableCell align={"right"}>{formatPeso(n.capitalPendiente)}</TableCell>
                </TableRow>
              )}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TableCell align={"right"}>{Strings.total}:</TableCell>
              <TableCell align={"right"}>{formatPeso(totalPago)}</TableCell>
              <TableCell align={"right"}>{formatPeso(totalInteres)}</TableCell>
              <TableCell align={"right"}>{formatPeso(totalCapital)}</TableCell>
              <TableCell align={"right"}>{formatPeso(totalSeguro)}</TableCell>
              <TableCell align={"right"}/>
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
      {data.length > 10 &&
        <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={data.length}
            rowsPerPage={rowsPerPage}
            SelectProps={{
              inputProps: { 'aria-label': 'No. registros' },
              native: true,
            }}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
        />
      }
    </>
  );
}

